import React from 'react';
import Box from '@sizeid/commons/components/Box';
import Text from '@sizeid/commons/components/Text';
import { Icon } from '@sizeid/commons/components/SvgImage';

const FormError: React.FC<{ message: string }> = props => (
  <Box margin="15px auto" align justify row>
    <Icon image="disabled" red />
    <Box marginLeft="10px">
      <Text bold danger>
        {props.message}
      </Text>
    </Box>
  </Box>
);

export default FormError;
